import logo_appentura_black from "./Appentura_black.svg"
import logo_appentura_white from "./Appentura_white.svg"
import icon_heart_empty_green from "./icon_heart_empty_green.svg"
import icon_heart_empty_white from "./icon_heart_empty_white.svg"
import icon_heart_full_green from "./icon_heart_full_green.svg"
import icon_heart_full_white from "./icon_heart_full_white.svg"
import logo_google_review from "./logo_google_review.png";
//import icon_participants from "./icon_participants_green.svg"
//import icon_options from "./icon_options_green.svg"
//import icon_weather_and_season from "./icon_weather_and_season_green.svg"
//import icon_conditions from "./icon_conditions_green.svg"
//import icon_benefits from "./icon_benefits_green.svg"
//import icon_region from  "./icon_region_green.svg"
import icon_invoice from "./icon_invoice_3.svg"
import icon_creditcard from "./icon_creditcard_2.svg"

//import icon_cart_green from "./icon_cart_green.svg"
//import icon_confirm_green from "./icon_confirm_green.svg"
//import icon_packaging_green from "./icon_packaging_green.svg"
//import icon_payment_green from "./icon_payment_green.svg"
//import icon_personalize_green from "./icon_personalize_green.svg"
//import icon_heart_green from "./icon_heart_full_green.svg"
//import icon_gift_green from "./icon_gift_green.svg"
//import icon_chat_green from "./icon_chat_white.svg";

//import icon_cart_white from "./icon_cart_white.svg"
//import icon_confirm_white from "./icon_confirm_white.svg"
//import icon_packaging_white from "./icon_packaging_white.svg"
//import icon_payment_white from "./icon_payment_white.svg"
//import icon_personalize_white from "./icon_personalize_white.svg"
import icon_search_white from "./icon_search_white.svg"
//import icon_heart_white from "./icon_heart_full_white.svg";
//import icon_chat_white from "./icon_chat_white.svg";
//import icon_menu_white from "./icon_menu_white.svg";
import icon_close_white from "./icon_close_white.svg"

//import icon_menu_black from "./icon_menu_black.svg"
//import icon_search_black from "./icon_search_black.svg"
import icon_close_black from "./icon_close_black.svg"

// hero
//import icon_hero_phone from "./icon_hero_phone.svg"
//import icon_hero_surprise from "./icon_hero_surprise.svg"
//import icon_hero_gift from "./icon_hero_gift.svg"

// header
//import icon_header_chat from "./icon_chat_green.svg"

// footer
//import icon_footer_email from "./icon_mail_white.svg"
//import icon_footer_location from "./icon_location_white.svg"
//import icon_footer_phone from "./icon_phone_white.svg"
//import logo_facebook from "./logo_facebook_white.svg"
//import logo_twitter from "./logo_twitter_white.svg"
//import logo_instagram from "./logo_instagram_white.svg"
//import logo_linkedin from "./logo_linkedin_white.svg"

//import seal_ssl from "./seal_ssl.svg"
//import seal_startup from "./seal_startup.svg"

// hero imags
import hero_winter from "./hero/couple_winter_2020_b.jpg";
import hero_summer from "./hero/couple_summer_2021.jpeg"

// country flags
import country_flag_switzerland from "./country_flag_switzerland.svg"
import country_flag_germany from "./country_flag_germany.svg"

export default {
  logos: {
    appentura: {
      black:logo_appentura_black,
      white:logo_appentura_white
    },
    googleReview: logo_google_review
    //facebook:logo_facebook,
    //twitter:logo_twitter,
    //instagram:logo_instagram,
    //linkedin:logo_linkedin
  },
  icons : {
    //benefits:icon_benefits,
    //conditions:icon_conditions,
    heart_empty_green: icon_heart_empty_green,
    heart_empty_white: icon_heart_empty_white,
    heart_full_white: icon_heart_full_white,
    heart_full_green: icon_heart_full_green,
    //options:icon_options,
    //participants:icon_participants,
    //region:icon_region,
    //weather_and_season:icon_weather_and_season,
    invoice:icon_invoice,
    creditcard:icon_creditcard,
    white: {
      //cart:icon_cart_white,
      //confirm:icon_confirm_white,
      //packaging:icon_packaging_white,
      //payment:icon_payment_white,
      //personalize:icon_personalize_white,
      search:icon_search_white,
      //heart:icon_heart_white,
      //chat:icon_chat_white,
      //menu:icon_menu_white,
      close:icon_close_white
    },
    green: {
      //cart:icon_cart_green,
      //confirm:icon_confirm_green,
      //packaging:icon_packaging_green,
      //payment:icon_payment_green,
      //personalize:icon_personalize_green,
      //heart:icon_heart_green,
      //gift:icon_gift_green,
      //chat:icon_chat_green
    },
    black: {
      //search:icon_search_black,
      //menu:icon_menu_black,
      close:icon_close_black
    },
    header: {
      //chat:icon_header_chat,
    },
    footer: {
      //phone:icon_footer_phone,
      //location:icon_footer_location,
      //email:icon_footer_email
    }
  },
  seals: {
    //ssl:seal_ssl,
    //startup:seal_startup
  },
  hero: {
    summer:hero_summer,
    winter:hero_winter,
    //phone:icon_hero_phone, // TODO obsolete?
    //surprise:icon_hero_surprise,  // TODO obsolete?
    //gift:icon_hero_gift  // TODO obsolete?
  },
  flags: {
    ch:country_flag_switzerland,
    de:country_flag_germany
  }
}